// ==================== OPERATING MODELS ====================

export const OPERATING_MODELS = {
  governanceStructures: {
    centralized: {
      name: 'Centralized CoE',
      description: 'Single AI Center of Excellence serving all business units',
      bestFor: ['startup', 'smb'],
      advantages: ['Consistent standards', 'Efficient resource use', 'Clear accountability'],
      disadvantages: ['Potential bottleneck', 'Less business alignment']
    },
    decentralized: {
      name: 'Decentralized Teams',
      description: 'AI teams embedded in each business unit',
      bestFor: ['enterprise'],
      advantages: ['Business alignment', 'Fast execution', 'Domain expertise'],
      disadvantages: ['Duplication', 'Inconsistent standards']
    },
    hybrid: {
      name: 'Hub-and-Spoke',
      description: 'Central CoE with embedded teams in business units',
      bestFor: ['enterprise', 'smb'],
      advantages: ['Best of both worlds', 'Scalable', 'Knowledge sharing'],
      disadvantages: ['Complex governance', 'Role clarity needed']
    }
  },
  
  decisionRights: {
    'Model Deployment': {
      approver: 'Head of AI + Business Owner',
      consultation: 'Risk, Compliance, IT',
      informed: 'Executive Committee'
    },
    'Data Access': {
      approver: 'Data Governance Committee',
      consultation: 'Privacy Office',
      informed: 'CDO'
    },
    'Budget > $100K': {
      approver: 'Steering Committee',
      consultation: 'Finance',
      informed: 'CEO'
    },
    'Architecture Changes': {
      approver: 'Enterprise Architecture Board',
      consultation: 'AI CoE',
      informed: 'CIO'
    },
    'Vendor Selection': {
      approver: 'Procurement + AI CoE',
      consultation: 'Legal',
      informed: 'CFO'
    }
  },
  
  careerPaths: {
    dataScientist: [
      { level: 'Junior DS', years: '0-2', skills: ['Python', 'ML Basics', 'Statistics'] },
      { level: 'Data Scientist', years: '2-5', skills: ['Deep Learning', 'Production ML', 'Feature Engineering'] },
      { level: 'Senior DS', years: '5-8', skills: ['Architecture Design', 'Mentoring', 'Research'] },
      { level: 'Lead DS', years: '8-12', skills: ['Strategy', 'Team Leadership', 'Innovation'] },
      { level: 'Principal DS', years: '12+', skills: ['Industry Expert', 'Thought Leadership', 'Advisory'] }
    ],
    mlEngineer: [
      { level: 'Junior MLE', years: '0-2', skills: ['Docker', 'CI/CD', 'Cloud Basics'] },
      { level: 'ML Engineer', years: '2-5', skills: ['Kubernetes', 'MLOps', 'Performance Optimization'] },
      { level: 'Senior MLE', years: '5-8', skills: ['Platform Design', 'Scalability', 'Security'] },
      { level: 'ML Architect', years: '8-12', skills: ['Enterprise Architecture', 'Technology Strategy'] },
      { level: 'Principal MLE', years: '12+', skills: ['Platform Vision', 'Technical Leadership'] }
    ]
  },
  
  teamStructures: {
    agile: {
      name: 'Agile AI Squad',
      roles: ['Product Owner', 'Data Scientist', 'ML Engineer', 'DevOps Engineer', 'QA'],
      size: '5-8 people',
      cadence: '2-week sprints',
      bestFor: ['startup', 'smb']
    },
    matrix: {
      name: 'Matrix Organization',
      roles: ['Program Manager', 'Data Science Lead', 'Engineering Lead', 'Business Analyst'],
      size: '10-20 people',
      cadence: 'Monthly planning',
      bestFor: ['enterprise']
    }
  }
};